const popLastColon = (name) => {
  if (!name) {
    return;
  }
  let str = name;
  const lastChar = str.charAt(str.length - 1, 1);
  if (lastChar == ":") {
    str = str.substring(0, str.length - 1);
  }
  return str;
};

exports.install = function(Vue, options) {
  Vue.prototype.removeFavoriteInCommon = function(obj) {
    //取消收藏
    const str = popLastColon(obj.number);
    var markedObject = {
      //post更改的值
      baseClassId: obj.baseClassId,
      objectNumber: str,
      id: obj.id,
      url: this.getPageUrl(obj.baseClassId),
      type: 1,
      userId: window.sessionStorage.getItem("currentUserId"),
    };
    var vm = this;
    this.$store.commit("setMyFavoriteObject", {
      baseClassId: obj.baseClassId,
      id: obj.id,
      number: str,
    });
    // console.log(this.$store.getters.getMyFavoriteObject);
    var ifExistingInMyFavorit = this.$store.getters.ifExistingInMyFavorit;
    // console.log(ifExistingInMyFavorit);
    if (ifExistingInMyFavorit === 1) {
      this.$http
        .post("/pmdm/search/removeMarkedObject", markedObject)
        .then(function(res) {
          if (res.data.code == 200) {
            vm.$store.commit("removeMyFavoriteIntoMenuList", {
              number: str,
              baseClassId: obj.baseClassId,
              id: obj.id,
            });
            vm.$message({
              message: vm.$t("message.success.removeFavoriteSuccessfully"),
              type: "success",
            });
          }
        })
        .catch(function(error) {
          vm.$message.error("取消收藏失败。");
          console.log(error);
        });
    }
  };
  Vue.prototype.addFavoriteInCommon = function(obj) {
    //添加收藏
    const str = popLastColon(obj.number);
    var markedObject = {
      //post更改的值
      baseClassId: obj.baseClassId,
      objectNumber: str,
      id: obj.id,
      url: this.getPageUrl(obj.baseClassId),
      type: 1,
      userId: window.sessionStorage.getItem("currentUserId"),
    };
    var vm = this;
    this.$store.commit("setMyFavoriteObject", {
      baseClassId: obj.baseClassId,
      number: str,
      id: obj.id,
    });
    // console.log(this.$store.getters.getMyFavoriteObject);
    var ifExistingInMyFavorit = this.$store.getters.ifExistingInMyFavorit;
    // console.log(ifExistingInMyFavorit);
    if (ifExistingInMyFavorit === 1) {
      this.$message({
        message: vm.$t("message.warning.alreadyInFavorite"),
        type: "success",
      });
      return;
    }
    this.$http
      .post("/pmdm/search/saveMarkedObject", markedObject)
      .then(function(res) {
        if (res.data.code == 200) {
          vm.$store.commit("pushMyFavoriteIntoMenuList", {
            number: str,
            baseClassId: obj.baseClassId,
            id: obj.id,
          });
          vm.$message({
            message: vm.$t("message.success.addFavoriteSuccessfully"),
            type: "success",
          });
        }
      })
      .catch(function(error) {
        vm.$message.error("收藏失败。");
        console.log(error);
      });
    //添加收藏
  };
  Vue.prototype.addRecentVistInCommon = function(obj) {
    const { id, classId, subClassId, baseClassId } = obj;
    const objectNumber = popLastColon(obj.number);
    const markedObject = {
      //post更改的值
      id,
      classId,
      subClassId,
      baseClassId,
      objectNumber,
      url: this.getPageUrl(baseClassId),
      type: 2,
      userId: window.sessionStorage.getItem("currentUserId"),
    };
    this.$store.dispatch("setRecentList", markedObject);
    // // console.log(markedObject);
    // this.$http
    //   .post("/pmdm/search/saveMarkedObject", markedObject)
    //   .then(function(res) {
    //     vm.$store.commit(
    //       "pushRecentVistIntoMenuList",
    //       res.data.object.markList
    //     );
    //   })
    //   .catch(function(error) {
    //     console.log(error);
    //   });
  };

  Vue.prototype.updateFavoriteInCommon = function(obj) {
    const str = popLastColon(obj.number);
    for (var i = 0; i < this.$store.state.menuList.length; i++) {
      if (this.$store.state.menuList[i].id == 104) {
        let oldFavorite = this.$store.state.menuList[i].children[0].children;
        // console.log(oldFavorite);
        for (var j = 0; j < oldFavorite.length; j++) {
          // console.log(oldFavorite[j].type);
          if (
            oldFavorite[j].id == obj.id &&
            oldFavorite[j].type == obj.baseClassId &&
            oldFavorite[j].name != str
          ) {
            this.updateFavoriteNameInCommon({
              baseClassId: obj.baseClassId,
              number: str,
              id: obj.id,
            });
          }
        }
      }
    }
  };

  Vue.prototype.updateFavoriteNameInCommon = function(obj) {
    //添加收藏
    const str = popLastColon(obj.number);
    var markedObject = {
      //post更改的值
      baseClassId: obj.baseClassId,
      objectNumber: str,
      id: obj.id,
      url: this.getPageUrl(obj.baseClassId),
      type: 1,
      userId: window.sessionStorage.getItem("currentUserId"),
    };
    var vm = this;
    this.$store.commit("setMyFavoriteObject", {
      baseClassId: obj.baseClassId,
      number: str,
      id: obj.id,
    });
    this.$http
      .post("/pmdm/search/saveMarkedObject", markedObject)
      .then(function(res) {
        if (res.data.code == 200) {
          vm.$store.commit("pushMyFavoriteIntoMenuList", {
            number: str,
            baseClassId: obj.baseClassId,
            id: obj.id,
          });
          // vm.$message({
          // 	message: res.data.message,
          // 	type: 'success'
          // });
        }
      })
      .catch(function(error) {
        vm.$message.error("收藏更新失败。");
        console.log(error);
      });
  };
};
